import { TherapeuticGroupType } from '@dreryk/egabinet-group-session-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { SelectTriggerLabelExtractor } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

export const useTriggerLabelExtractor = (): SelectTriggerLabelExtractor<TherapeuticGroupType | null> => {
   const translate = useTranslate();
   return (type) => {
      if (!type) {
         return '';
      }

      return translate(translationKeys.groupSessionsTypeMap[type]);
   };
};
